<template>
  <v-container>
    <v-row justify="center" id="header" align="center">
      <v-col cols="12" md="7">
        <h2>Mentions légales</h2>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" md="7">
        <h3 class="mt-5">Raison sociale</h3>
        <p><b>PAGESTI SAS - capital de 76 180 €</b></p>
        <p>
          <b>Siège social : </b>56 rue du Faubourg Saint-Antoine, Paris 75012,
          France
        </p>
        <p>
          <b>Réception des appels : </b> 01 44 75 74 80<br />
          Lundi au vendredi : 08h00 - 20h00 <br />
          Samedi : 08h00 - 13h00 <br />
          <b>Email : </b>
          <a href="mailto:welcome@pagesti.immo">welcome@pagesti.immo</a>
        </p>
        <v-divider class="my-4"></v-divider>
        <p><b>RCS : Paris </b>325 314 623</p>
        <p>
          <b>Carte professionnelle : </b>CPI 7501 2016 000 012 823 délivrée par
          la CCI de Paris Île-de-France.
        </p>
        <p>
          <b>Caisse de garantie financière :</b><br />
          GALIAN – 128 rue de la Boétie, 75008 PARIS à hauteur de <br />
          4 000 000€ au titre de l’activité de Syndic <br />
          860 000€ au titre de l’activité de Gestion Immobilière <br />
          120 000€ au titre de l’activité de Transactions sur Immeubles et Fonds
          de commerce
        </p>
        <p>
          <b>Assurance responsabilité civile professionnelle :</b> GALIAN – 128
          rue de la Boétie, 75008 PARIS
        </p>
        <p>
          <b>Numéro individuel d’identification à la TVA :</b> FR12 325 314 623
          00068
        </p>
        <p>
          Adhérent à la Fédération Nationale de l’Immobilier (FNAIM), ayant le
          titre professionnel d’Administrateur de Biens obtenu en France.
        </p>
        <p>
          PAGESTI SAS exerce la profession d’administrateur de biens. Ses
          activités de Syndic de Copropriété et Gestion immobilière sont régies
          par la Loi Hoguet n° 70-9 du 2 janvier 1970.
        </p>
        <h3 class="mt-5">
          Directeur de publication & responsable de la rédaction
        </h3>
        <p>Arnaud Le Bihannic, Président de PAGESTI SAS.</p>
        <h3 class="mt-5">Mise en garde générale</h3>
        <p>
          <b>
            LES INFORMATIONS PRÉSENTES SUR CE SITE N’ONT PAS DE VALEUR
            CONTRACTUELLE.
          </b>
        </p>
        <p>
          PAGESTI ne peut être tenu responsable en cas de mauvaise utilisation
          du service par le client ou en cas d’indisponibilité temporaire du
          service (cas de force majeure, de période de maintenance ou d’incident
          technique, quel qu’il soit).
        </p>
        <h3 class="mt-5">Droit de propriété intellectuelle</h3>
        <p>
          LA STRUCTURE GÉNÉRALE DU SITE AINSI QUE LES TEXTES, IMAGES ANIMÉES OU
          NON, VIDÉOS ET LES SONS SONT LA PROPRIÉTÉ DE PAGESTI. TOUTE
          UTILISATION OU REPRODUCTION, TOTALE OU PARTIELLE, DES INFORMATIONS
          FIGURANT SUR LE SITE EST STRICTEMENT INTERDITE.
        </p>
        <h3 class="mt-5">Herbergement du site</h3>
        <p>
          OVH 14,<br />
          Quai de Sartel <br />
          59100 ROUBAIX France
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>

<style lang="scss">
#header {
  height: 30vh;
}
</style>
